import axios from '../../plugins/axios'
import financeiro from "../../plugins/FinanceiroInterceptor";
import calculosEconomia from "../../plugins/CalculosEconomiaInterceptor";

export const actions = {
    gerarRelatorioPreFatura(context, payload) {
        return new Promise((resolve, reject) => {
            financeiro.get(`relatorios/pre-faturas?` + payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    gerarRelatorioBalanco(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`relatorios/balanco-energetico?` + payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    gerarRelatorioFaturasCemig(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`relatorios/faturas-cemig?` + payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    setupFazendaReportJob(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`relatorios/setup-fazenda`, payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    gerarRelatorioFazendaDivergentes(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`relatorios/fazendas-divergentes?`+ payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    gerarRelatorioDinamico(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`relatorios/dinamico`, payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    gerarRelatorioDescontos(context, payload) {
        return new Promise((resolve, reject) => {
            financeiro.get(`relatorios/descontos?` + payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    gerarRelatorioGdCemig(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`relatorios/relatorio-gd-cemig`, payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    gerarRelatorioCalculosEconomia(context, payload) {
        return new Promise((resolve, reject) => {
            calculosEconomia.get(`relatorio?`+ payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/relatorios.js